import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/static/landingPageGTop/redetop.png'
import _imports_1 from '../../assets/static/landingPageGTop/obencard.png'
import _imports_2 from '../../assets/static/landingPageGTop/preceiro.png'


const _withScopeId = n => (_pushScopeId("data-v-342e4eb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "supporters" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logotipos" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    title: "Rede Top",
    class: "logo",
    alt: "Rede Top"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "logo",
    title: "Obencard",
    alt: "Obencard"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    title: "Preceiro",
    alt: "Preceiro",
    class: "logo"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}